import React, { useEffect, useState } from 'react';
import HastaSecModal from './HastaSecModal';
import { getDoktorPersonel, getDoktorGonderen, getTarifeListesi, getGelisTuruListesi, kabulYap } from '../services/api';

const bugunYmd = () => new Date().toLocaleDateString('sv-SE'); // yyyy-mm-dd

// "YENİ KABUL YAP" popup'ı — hasta seç + tarih/doktor/tarife/gönderen/geliş türü toplayıp
// api/kabul/yeni'ye gönderir (kullanıcı talebi: 2026-08-09).
export default function YeniKabulModal({ onKapat, onKabulYapildi }) {
  const [seciliHasta, setSeciliHasta] = useState(null);
  const [hastaSecAcik, setHastaSecAcik] = useState(false);

  const [tarih, setTarih] = useState(bugunYmd());
  const [dokKod, setDokKod] = useState('');
  const [tarifeKod, setTarifeKod] = useState('');
  const [gonderenKod, setGonderenKod] = useState('');
  const [gelisTuruId, setGelisTuruId] = useState('');

  const [doktorlar, setDoktorlar] = useState([]);
  const [gonderenler, setGonderenler] = useState([]);
  const [tarifeler, setTarifeler] = useState([]);
  const [gelisTurleri, setGelisTurleri] = useState([]);

  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [hata, setHata] = useState('');

  useEffect(() => {
    getDoktorPersonel().then(res => {
      setDoktorlar(res.data);
      if (res.data.length > 0) setDokKod(String(res.data[0].kod));
    }).catch(err => console.error(err));

    getTarifeListesi().then(res => {
      setTarifeler(res.data);
      if (res.data.length > 0) setTarifeKod(String(res.data[0].kod));
    }).catch(err => console.error(err));

    getDoktorGonderen().then(res => setGonderenler(res.data)).catch(err => console.error(err));
    getGelisTuruListesi().then(res => setGelisTurleri(res.data)).catch(err => console.error(err));
  }, []);

  const hastaSecildi = (hasta) => {
    setSeciliHasta(hasta);
    setHastaSecAcik(false);
  };

  const gecerli = seciliHasta && tarih && dokKod && tarifeKod;

  const kabulYapTiklandi = async () => {
    if (!gecerli) { setHata('Hasta, tarih, doktor ve tarife seçimi zorunludur.'); return; }
    setHata(''); setKaydediliyor(true);
    try {
      const kullanici = JSON.parse(localStorage.getItem('kullanici') || '{}');
      const res = await kabulYap({
        kayitNo: seciliHasta.kayitNo,
        tar: tarih,
        dokKod: Number(dokKod),
        tarifeKod: Number(tarifeKod),
        gonderenKod: gonderenKod ? Number(gonderenKod) : null,
        gelisTuruId: gelisTuruId ? Number(gelisTuruId) : null,
        whoNo: kullanici.noo || 85,
      });
      onKabulYapildi(res.data.masterProtNo);
    } catch (err) {
      setHata(err.response?.data?.hata || 'Kabul yapılamadı.');
    } finally {
      setKaydediliyor(false);
    }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div className="card" style={{ width: 480, maxWidth: '92vw', maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
          <h3 style={{ margin: 0, fontSize: 14, color: 'var(--med-dark)' }}>Yeni Kabul Yap</h3>
          <button onClick={onKapat} className="btn btn-secondary" style={{ fontSize: 12, padding: '4px 10px' }}>✕</button>
        </div>

        <div style={{ flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div>
            <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: 4 }}>Hasta *</label>
            {seciliHasta ? (
              <div
                onClick={() => setHastaSecAcik(true)}
                style={{ border: '1px solid var(--border)', borderRadius: 8, padding: '8px 12px', cursor: 'pointer', background: 'var(--med-light)' }}
              >
                <div style={{ fontWeight: 500, fontSize: 13 }}>{seciliHasta.hesapAdi}</div>
                <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>#{seciliHasta.kayitNo} — değiştirmek için tıklayın</div>
              </div>
            ) : (
              <button onClick={() => setHastaSecAcik(true)} className="btn btn-secondary" style={{ width: '100%' }}>
                🔍 Hasta Seç
              </button>
            )}
          </div>

          <div>
            <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: 4 }}>Tarih *</label>
            <input type="date" value={tarih} onChange={e => setTarih(e.target.value)} style={{ width: '100%' }} />
          </div>

          <div>
            <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: 4 }}>Doktor *</label>
            <select value={dokKod} onChange={e => setDokKod(e.target.value)} style={{ width: '100%' }}>
              {doktorlar.length === 0 && <option value="">—</option>}
              {doktorlar.map(d => <option key={d.kod} value={d.kod}>{d.doktorAdi}</option>)}
            </select>
          </div>

          <div>
            <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: 4 }}>Tarife *</label>
            <select value={tarifeKod} onChange={e => setTarifeKod(e.target.value)} style={{ width: '100%' }}>
              {tarifeler.length === 0 && <option value="">—</option>}
              {tarifeler.map(t => <option key={t.kod} value={t.kod}>{t.tarifeAdi}</option>)}
            </select>
          </div>

          <div>
            <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: 4 }}>Gönderen</label>
            <select value={gonderenKod} onChange={e => setGonderenKod(e.target.value)} style={{ width: '100%' }}>
              <option value="">Seçilmedi</option>
              {gonderenler.map(d => <option key={d.kod} value={d.kod}>{d.doktorAdi}</option>)}
            </select>
          </div>

          <div>
            <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: 4 }}>Geliş Türü</label>
            <select value={gelisTuruId} onChange={e => setGelisTuruId(e.target.value)} style={{ width: '100%' }}>
              <option value="">Seçilmedi</option>
              {gelisTurleri.map(g => <option key={g.id} value={g.id}>{g.adi}</option>)}
            </select>
          </div>
        </div>

        {hata && <div style={{ background: '#FCEBEB', color: '#A32D2D', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginTop: 10 }}>{hata}</div>}

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 14 }}>
          <button onClick={onKapat} className="btn btn-secondary">Vazgeç</button>
          <button onClick={kabulYapTiklandi} disabled={kaydediliyor || !gecerli} className="btn btn-primary">
            {kaydediliyor ? 'Kaydediliyor...' : 'KABUL YAP'}
          </button>
        </div>
      </div>

      {hastaSecAcik && (
        <HastaSecModal onKapat={() => setHastaSecAcik(false)} onSec={hastaSecildi} />
      )}
    </div>
  );
}
